"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsDesktop = exports.useIsMobile = void 0;
var react_responsive_1 = require("react-responsive");
var theme_1 = require("../theme");
var useIsMobile = function () {
    return (0, react_responsive_1.useMediaQuery)({ maxWidth: theme_1.theme.breakpoints.mobile });
};
exports.useIsMobile = useIsMobile;
var useIsDesktop = function () {
    return (0, react_responsive_1.useMediaQuery)({ minWidth: theme_1.theme.breakpoints.desktop });
};
exports.useIsDesktop = useIsDesktop;
